import React from 'react'
import { inject, observer } from 'mobx-react'

import TicketLoader from './TicketLoader'
import Spacer from '~/components/Spacer'
import DesktopContainer from '~/components/DesktopContainer'

@inject(all => ({
  isMobile: all.store.ui.isMobile,
  fetcherName: all.store.trafficLookup.fetcherName
}))
@observer
class TicketSearch extends React.Component {
  render() {
    return (
      <>
        <DesktopContainer>
          <Spacer mobile={66} desktop={130} />
          <TicketLoader fetcher={this.props.fetcherName}/>
          <Spacer mobile={250} desktop={500} />
        </DesktopContainer>
      </>
    )
  }
}

export default TicketSearch
